import config from 'app-self-support-order/config'

const customerApi = `${config.apiHost}/oem-customer`

export default {
    // 创建群发
    createMsg: {
        url: `${customerApi}/api/mass_sending`,
        type: 'POST',
    },

    // 计算过滤后的群发客户数量
    getFilterCustomerCount: {
        url: `${customerApi}/api/mass_sending/prepare`,
        type: 'POST',
    },
}
